// src/components/Product/ProductLink.jsx
import React from "react";
import { PillButton } from '../../ui/Button/index';
import ExternalLink from '../../ui/ExternalLink';
import { extractDomainName, cn } from '../../../lib/utils';

/**
 * ProductLink Molecule - Displays a pill-shaped external link to a product
 * Positioned absolutely at bottom-left of parent container
 * Shows domain name on mobile, expands to show full domain on hover (desktop)
 * 
 * @component
 * @example
 * <ProductLink url="https://www.amazon.com/product/123" />
 */
const ProductLink = ({ url }) => {
  if (!url) {
    return null;
  }

  const domainName = extractDomainName(url);

  return (
    <div className="absolute bottom-2 left-2">
      <PillButton
        variant="custom"
        size="sm"
        className="
      group
      px-1 py-1 mx-1 text-center text-sm
      text-red-50 bg-red-300 border-2 border-red-300
      lg:text-red-300 lg:bg-transparent lg:border-red-300 
      lg:group-hover:bg-red-50
      lg:hover:!bg-red-400 lg:hover:!text-red-50 lg:hover:!border-red-400
      hover:shadow-md
      transition-all duration-200
    "
        onClick={() => window.open(url, "_blank")}
      >
        <ExternalLink
          href={url}
          className="gap-3"
          iconW={5}
          iconH={5}
        >
          <span
            className="
          max-w-[150px] pl-1 truncate
          lg:max-w-0 lg:overflow-hidden
          lg:group-hover:max-w-[150px] lg:group-hover:pl-1 
          group-hover:max-w-[150px] group-hover:pl-1
          transition-all duration-200 ease-in-out
        "
          >
            {domainName}
          </span>
        </ExternalLink>
      </PillButton>
    </div>
  );
};

export default ProductLink;

